import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import {  isSupervisor, isTeamLead } from '../Authetication'



export default function StoreSupervisorRoutes() {


  let auth = {"token": isSupervisor()}

  

  return (
   auth.token ? <Outlet/> : <Navigate to="/dashboard"/>
  )
}
